import { useState } from 'react';
import { Actions, Flex, FlexItem, Grid } from '@gusto/workbench';
import { NumberField, Option, SelectField, SubmitButton, TextField } from '@gusto/workbench-formik';
import FormattedPhoneField from 'packages/signup/components/signupForm/formattedPhoneField';
import { INDUSTRY_SETTING_OPTIONS } from './constants';

type LeadFormDetailsProps = {
  contractorOnly?: boolean;
  primaryCTACopy: string;
  isFilledOutLeadForm?: boolean;
  primaryCTAOnClick?: () => void;
};

export default function LeadFormDetails({
  contractorOnly = false,
  primaryCTACopy,
  isFilledOutLeadForm,
  primaryCTAOnClick,
}: LeadFormDetailsProps) {
  const [industrySetting, setIndustrySetting] = useState('');

  return (
    <Grid width="100%" maxWidth="635px" autoRows="max-content" rowGap={5}>
      {!isFilledOutLeadForm && (
        <>
          <Flex columnGap={3} rowGap={3} flexDirection="column" flexDirectionMd="row">
            <FlexItem width={1} widthMd={1 / 2}>
              <TextField
                name="firstName"
                id="firstName"
                type="text"
                label="First name"
                placeholder="First name"
                required
                autoComplete="given-name"
              />
            </FlexItem>
            <FlexItem width={1} widthMd={1 / 2}>
              <TextField
                name="lastName"
                id="lastName"
                type="text"
                label="Last name"
                placeholder="Last name"
                required
                autoComplete="family-name"
              />
            </FlexItem>
          </Flex>
          <TextField
            name="email"
            id="email"
            type="email"
            label="Work email"
            placeholder="Work email address"
            required
            autoComplete="email"
          />
          <TextField
            name="companyName"
            id="companyName"
            type="text"
            label="Company name"
            placeholder="Company name"
            required
          />
          <Flex columnGap={3} rowGap={3} flexDirection="column" flexDirectionMd="row">
            <FlexItem width={1} widthMd={1 / 2} flexGrow={1} alignSelf="stretch">
              <NumberField
                name="numberEmployees"
                id="numberEmployees"
                label="No. of employees"
                placeholder={contractorOnly ? 'No. of contractors' : 'No. of employees'}
                inputMode="numeric"
                required
                min={0}
                max={99999}
                step={1}
              />
            </FlexItem>
            <FlexItem width={1} widthMd={1 / 2} flexGrow={1}>
              <FormattedPhoneField
                name="phone"
                label="Company phone"
                type="tel"
                placeholder="(555) 012-3456"
                autoComplete="tel"
              />
            </FlexItem>
          </Flex>
          <SelectField
            name="industry"
            id="industry"
            label="Industry"
            required
            onChange={e => setIndustrySetting(e.target.value)}
            className={industrySetting === '' ? 'c-salt-500' : ''}
          >
            {INDUSTRY_SETTING_OPTIONS.map(industry => (
              <Option key={industry.value} value={industry.value}>
                {industry.label}
              </Option>
            ))}
          </SelectField>
        </>
      )}
      {isFilledOutLeadForm ? (
        <Actions justifyContent="center">
          <SubmitButton
            className="btn btn-primary btn-submit-form btn-submit-explore"
            type="submit"
            id="filled-out-lead-submit"
            onClick={primaryCTAOnClick}
          >
            {primaryCTACopy}
          </SubmitButton>
        </Actions>
      ) : (
        <SubmitButton
          className=" btn btn-primary btn-submit-form"
          type="submit"
          id="submit"
          onClick={primaryCTAOnClick}
        >
          {primaryCTACopy}
        </SubmitButton>
      )}
    </Grid>
  );
}
